import { Stack, useColorMode } from '@chakra-ui/react';
import PageLayout from '../layouts/PageLayout';
import { Companies, Educations, SelfDirectedLearning } from '../ui/Career';

function AboutPage() {
  const { colorMode } = useColorMode();

  return (
    <PageLayout seoKey="experience">
      <Stack
        as="main"
        width="100%"
        maxWidth="64rem"
        spacing={{ base: 12, md: 16 }}
        px={{ base: 5, md: 8 }}
        pt={{ base: 4, md: 8 }}
        pb={{ base: 10, md: 15 }}
        mx="auto"
      >
        <Companies colorMode={colorMode} />
        <Educations colorMode={colorMode} />
        <SelfDirectedLearning colorMode={colorMode} />
      </Stack>
    </PageLayout>
  );
}

export default AboutPage;
